import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SyncfusionModule } from '../../shared/syncfusion.module';
import { SharedModule } from '../../shared/shared.module';
import { ProductCatalogComponent } from './product-catalog.component';
import { ProductCatalogRoutingModule } from './product-catalog.routing.module';
import { ItemInfoPopupComponent } from './item-info-popup/item-info-popup.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { UploaderAllModule } from '@syncfusion/ej2-angular-inputs';
import { CartPopupComponent } from './cart-popup/cart-popup.component';
import { ProductCatalogPopupComponent } from './product-catalog-popup/product-catalog-popup.component';
import { ConfiguredItemPopupComponent } from './configured-item-popup/configured-item-popup.component';
@NgModule({
    declarations: [
        ProductCatalogComponent,
        ItemInfoPopupComponent,
        CartPopupComponent,
        ProductCatalogPopupComponent,
        ConfiguredItemPopupComponent
    ],
    imports: [
        CommonModule,
        ProductCatalogRoutingModule,
        SyncfusionModule,
        UploaderAllModule,
        SharedModule,
        RichTextEditorAllModule,
        
    ],
    exports: [
        ProductCatalogComponent,
        ItemInfoPopupComponent,
        ProductCatalogPopupComponent,
        ConfiguredItemPopupComponent
    ]
})
export class ProductCatalogModule { }
